var _path, _path2, _path3, _path4, _rect, _path5, _path6, _path7, _path8, _path9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHouse(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49 27.5H43L31 20.5L27.5 16.5H42L49 27.5Z",
    fill: "#FEB6C8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8076 5.82105C17.2124 5.38318 17.9081 5.3947 18.2982 5.84574L32.5693 22.3458C33.1296 22.9936 32.6694 24 31.8129 24H2.28648C1.41434 24 0.96015 22.9615 1.55222 22.3211L16.8076 5.82105Z",
    stroke: "#E40038",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5 16.5H39.9415C41.2333 16.5 42.4456 17.1239 43.1965 18.175L48.9353 26.2094C49.1717 26.5403 48.9351 27 48.5284 27H46C45.4477 27 45 27.4477 45 28V39.5",
    stroke: "#E40038",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4 24H31V39C31 39.5523 30.5523 40 30 40H5C4.44771 40 4 39.5523 4 39V24Z",
    stroke: "#E40038",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 40,
    width: 48,
    height: 5,
    rx: 2.5,
    stroke: "#E40038",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5 27H31.5",
    stroke: "#E40038",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5 31V40H40.5V31H35.5Z",
    stroke: "#E40038",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M19 31.5C19 29.567 20.567 28 22.5 28V28C24.433 28 26 29.567 26 31.5V40H19V31.5Z",
    fill: "#FEB6C8",
    stroke: "#E40038",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M14 16C14 14.3431 15.3431 13 17 13V13C18.6569 13 20 14.3431 20 16V19H14V16Z",
    stroke: "#E40038",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 31C8.5 29.3431 9.84315 28 11.5 28V28C13.1569 28 14.5 29.3431 14.5 31V34H8.5V31Z",
    stroke: "#E40038",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHouse);
export default __webpack_public_path__ + "static/media/house.25117bd4e80aa2a17532cb28e6359843.svg";
export { ForwardRef as ReactComponent };